module.exports = __webpack_public_path__ + "static/404-mobile-b171ec99fc91c1e3068fb547b7437c61.svg";